<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    show-close
    width="500px"
    :title="title || defaultTitle"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <el-form
      ref="designForm"
      :model="formData"
      size="medium"
      label-width="100px"
      :rules="rules"
      style="margin-top: 30px; margin-bottom: 12px"
    >
      <el-row :gutter="20">
        <el-col :span="22">
          <el-form-item
            :label="$l('form_label_begin_date') || '展会开始日期'"
            prop="beginDate"
          >
            <el-date-picker
              v-model="formData.beginDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('tips_select_begin_time') || '请选择展会开始时间'
              "
              style="width: 100%"
              :picker-options="beginDatePicker"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="22" class="mt-1">
          <el-form-item
            :label="$l('form_label_end_date') || '展会结束日期'"
            prop="endDate"
          >
            <el-date-picker
              v-model="formData.endDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              :placeholder="$l('tips_select_end_time') || '请选择展会结束时间'"
              style="width: 100%"
              :picker-options="endDatePicker"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close">{{
        $l('btn_cancel_date') || '取消'
      }}</el-button>
      <el-button type="primary" size="small" @click="confirm()">{{
        $l('product_dialog_btn_confirm_date') || '确定'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  components: {},
  props: {
    visible: { type: Boolean, default: false },
    expoInfoCode: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  created() {
    this.getData()
  },
  data() {
    return {
      defaultTitle: this.$l('diageo_update_expoInfo_time') || '展会时间调整',
      formData: { beginDate: '', endDate: '' },

      rules: {
        beginDate: [
          {
            required: true,
            message: this.$l('tips_select_begin_time') || '请选择展会开始时间',
            trigger: 'change',
          },
        ],
        endDate: [
          {
            required: true,
            message: this.$l('tips_select_end_time') || '请选择展会结束时间',
            trigger: 'change',
          },
        ],
      },
      //展会时间限制
      beginDatePicker: this.endDate(),
      endDatePicker: this.beginDate(),
    }
  },
  methods: {
    getData() {
      if (!this.expoInfoCode) return
      if (this.loadingOpen()) return
      this.$api
        .expoInfoDetailApi({
          expoInfoCode: this.expoInfoCode,
        })
        .then((res) => {
          this.loadingClose()
          this.formData.beginDate = res.body.beginDate
          this.formData.endDate = res.body.endDate
          this.formData.expoInfoCode = res.body.expoInfoCode
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('update:expoInfoCode', '')
    },
    async confirm() {
      const result = await validate.formValidate([this.$refs.designForm])
      if (!result) return
      this.$emit('confirm', this.formData)
    },
    // 创建日期限制
    endDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.endDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.formData.endDate).getTime() < time.getTime()
          }
        },
      }
    },
    beginDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.beginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.formData.beginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
